module.exports = __webpack_public_path__ + "img/three2Green.213ef52f.jpg";